import apiClient from './_axios';

interface WalletChargeDataBilling {
   storeId: string;
   amount: number;
   billingId: string;
   /** Which method the operator picked, e.g. 'MAYA'. Left out means GCash —
    *  the only channel that existed before the picker. */
   channel?: string;
}

export interface PaymentChannel {
   code: string;
   label: string;
   minAmount: number;
   maxAmount: number;
}

/**
 * The online payment methods that are live right now, for this amount.
 *
 * A failure returns an empty list on purpose: offering a method we cannot
 * confirm is live sends the operator to a checkout that cannot take money.
 */
export const fetchPaymentChannels = async (
   amount: number
): Promise<PaymentChannel[]> => {
   try {
      const response = await apiClient.get('/payment-channels', {
         params: { amount },
      });
      return Array.isArray(response.data?.channels) ? response.data.channels : [];
   } catch {
      return [];
   }
};

interface CreateBillingPending {
   storeId: string;
   subscribe: string;
}

export const createBillingPending = async (data: CreateBillingPending) => {
   // console.log(`xdata----`, data);
   const response = await apiClient.post(
      '/billing/create-billing-pending',
      data
   );
   return {
      data: response.data,
      status: response.status,
   };
};

export const createWalletChargeXenditBilling = async (
   data: WalletChargeDataBilling
) => {
   const response = await apiClient.post(
      '/billing/create-xendit-charge-billing',
      data
   );
   return response.data;
};

export const verifyBillingSuccess = async (billingId: string) => {
   // console.log(`billingId----`, billingId);
   const response = await apiClient.get(
      `/billing/verify-billing-success/${billingId}`
   );
   return {
      data: response.data,
      status: response.status,
   };
};

export const fetchBilling = async () => {
   const response = await apiClient.get('/billing/billing-list');
   return response.data;
};

export const cancelBilling = async (billingId: string) => {
   const response = await apiClient.delete(
      `/billing/cancel-billing/${billingId}`
   );
   return response.data;
};
